import React, { useContext, useEffect, useMemo, useState } from 'react';
import { endpoints } from '../../../config/connections';
import callApi from '../../components/utilities/callApi';
import { getQS, saveAsFile } from '../../components/utilities/Utils';
import { useNavigate } from 'react-router-dom'
import { USBGrid, USBColumn, USBSelect, USBButton } from '@usb-shield/components-react';
import USBBreadcrumb from '@usb-shield/components-react/dist/cjs/breadcrumb';
import { FeatureCategoryContext } from '../../components/Hooks/useFeatureCategories';

const FindByRequirementId = () => {

    const [loadinger, setLoading] = useState(false);
    const [requirementId, setRequirementId] = useState("");
  const { categories } = useContext(FeatureCategoryContext);
  const navigate = useNavigate();

  const inboxCategoryLookup = useMemo(() => {
    const inboxCategory = categories.find((category) => category.key === 'inboxCategory');
    const inboxItems = inboxCategory?.items || [];
    return new Set(inboxItems.map((item) => item.toLowerCase()));
  }, [categories]);

  const closingBinderCategoryLookup = useMemo(() => {
    const closingBinderCategory = categories.find((category) => category.key === 'redirectCategory');
    const closingBinderItems = closingBinderCategory?.items || [];
    return new Set(closingBinderItems.map((item) => item.toLowerCase()));
  }, [categories]);

 
    const requirementDetailApiCall = () => {
      const apiURL = `${endpoints.apigee}/document-management/cdc/requirements/v1/documents/${requirementId}/details`;
      if (requirementId) {
        callApi
          .getApiDataRequirement(apiURL)
          .then((result) => {


              if (result?.data?.isDeleted) {
              alert('Record has been deleted or is no longer available.');
              navigate('/ReportingDashboard');
              setLoading(false);
              return;
            }

            const alternateStatus = result?.data?.alternateStatus;
            const isSendDocsAltStatus = ['Send Docs to Accountant', 'Send Supporting Docs', 'Sending Supporting Docs'].includes(alternateStatus);
            const isRequestFromAccountantAltStatus = ['Request Draft from Accountant', 'Request Final from Accountant'].includes(alternateStatus);

            if (isRequestFromAccountantAltStatus) {
              navigate(`/RequirementDetails?id=${requirementId}`);
            } else if (closingBinderCategoryLookup.has(result?.data?.category?.toLowerCase())) {
              navigate(`/ClosingBinders/Portfolio/Requirements?id=${requirementId}`);
            } else if (isSendDocsAltStatus || inboxCategoryLookup.has(result?.data?.category?.toLowerCase())) {
              navigate(`/Inbox/${requirementId}`);
            } else if (result?.data?.category?.length > 0) {
              navigate(`/RequirementDetails?id=${requirementId}`);
            } else {
              alert('This Requirement Id is not found. Please search with valid Requirement Id.');
            }
          })
          .catch((error) => {
            console.error('Error fetching requirement data:', error);
          });
      }
    };

    useEffect(() => {
      if(categories.length>0){
        console.log('categories', categories);
        setRequirementId(getQS('id')||"");
      }
    }, [categories]);

    useEffect(() => {
 
      requirementDetailApiCall();
  }, [requirementId, navigate]);

    return (
        <>
      <USBGrid addClasses="content-frame">
        <USBColumn largeSpan={8}>
          <USBBreadcrumb
            id="reports"
            data-testid="breadcrumb"
            text="Reports"
            breadcrumbs={[
              { id: 1, text: 'Home', href: '/Redirect' },
              { id: 2, text: 'Find By Requirement Id', href: '' },
            ]}
          />
        </USBColumn>
        <USBColumn largeSpan={8}></USBColumn>
      </USBGrid>
      <USBGrid  data-testid="main" addClasses="content-frame content-bg">

        <USBColumn largeSpan={16}>

         
          <div className="sorting-inputs">
           
            <div className="filter-dropdowns-lookup searchInputValue">
              <label>
               Enter Requirement Id : <input
                  type="text"
                  data-testid="main" 
                  name="name"
                  id="searchInput"
                  size={40}
                  value={requirementId}
                  onChange={(e) => {
                    setRequirementId(e.target.value);
                  }}
                />
              </label>
            </div>
            <div className="filter-dropdowns-lookup searchButton">
              <USBButton
                type="button"
                variant="primary"
                size="small"
                id="searchButton"
                name="searchButton"
                disabled={false}
                handleClick={() => {
                  requirementDetailApiCall();
                }}
              >
                Search
              </USBButton>
            </div>
           <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/> <br/>
        </div>
        </USBColumn>
      </USBGrid>
    </>

    )
}

export default FindByRequirementId
